import React, { useState } from "react";
//import "./bulma.min.css";
import "./App.scss";
import {
  Block,
  Button,
  Columns,
  Container,
  Form,
  Section,
  Heading,
  Table,
} from "react-bulma-components";
import ChannelCard from "./components/channelCard";
import axios from "axios";
import { useEffect } from "react";
import PackagePicker from "./components/packagePicker";
import FilterSummary from "./components/filterSummary";
import ChannelRow from "./components/channelRow";

const { Input, Field, Control, Label } = Form;

function Channels() {
  //Set up states
  const [allChannels, setAllChannels] = useState([]);
  const [filteredChannels, setFilteredChannels] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [dma, setDMA] = useState("Arkansas");
  const [tier, setTier] = useState("");
  const [tiers, setTiers] = useState([]);

  //Load channel data from JSON file and set initial values. Only do this on first mount.
  useEffect(() => {
    const fetchChannels = async () => {
      const { data } = await axios.get(
        "https://ozarksgo.wpengine.com/wp-json/custom/v1/channels"
      );
      //const { data } = await axios.get("../channels.json");
      data.sort((a, b) => a.number - b.number);
      setAllChannels(data);
      setFilteredChannels(allChannels);
    };
    fetchChannels();
  }, []);

  //Tier picker TODO
  useEffect(() => {
    const packages = [];
    allChannels.map((channel) => {
      if (packages.indexOf(channel.packages[0]) === -1) {
        packages.push(channel.packages[0]);
      }
      setTiers(packages);
    });
  }, [allChannels]);

  //Use filter value to search value from user input. If no user input, show all channels.
  useEffect(() => {
    //If search input is empty and tier is empty, show all channels
    if (searchInput === "" && tier === "") {
      setFilteredChannels(allChannels.filter((c) => c.state.includes(dma)));
    }

    //If search input is empty and tier is selected, show all channels for tier and clear search
    if (searchInput === "" && tier !== "") {
      setFilteredChannels(
        allChannels.filter(
          (c) => c.state.includes(dma) && c.packages.includes(tier)
        )
      );
    }

    //If search input is filled but tier is empty, show search results for all channels
    if (searchInput !== "" && tier === "") {
      setFilteredChannels(
        allChannels.filter(
          (c) =>
            (c.state.includes(dma) &&
            c.name.toLowerCase().includes(searchInput.toLowerCase()) ||
            c.state.includes(dma) && 
            c.number.toString() === searchInput
            )
        )
      );
    }

    //If search input is filled and tier is selected, show search results and clear tier
    if (searchInput !== "" && tier !== "") {
      setTier("");
      setFilteredChannels(
        allChannels.filter(
          (c) =>
            c.name.toLowerCase().includes(searchInput.toLowerCase()) &&
            c.state.includes(dma) &&
            c.packages.includes(tier)
        )
      );
    }
  }, [allChannels, searchInput, dma, tier]);

  //Handle click of state selection buttons. Update DMA state and set active button.
  const handleClick = (e) => {
    setDMA(e.target.id);
    setDMA(e.target.value);
  };

  //Handle tier filters
  const handleTier = (e) => {
    setTier(e.target.value);
    setSearchInput("");
    console.log("Value is " + e.target.value + " tier is " + tier);
  };

  const clearTier = () => {
    setTier("");
  };

  const Channels = filteredChannels.map((item) => (
    <Columns.Column key={item.id} size={"one-third"}>
      <ChannelCard
        name={item.name}
        number={item.number}
        package={item.package}
        onclick={handleTier}
      />
    </Columns.Column>
  ));

  const ChannelTableBody = filteredChannels.map((item) => (
    <ChannelRow
      key={item.ID}
      number={item.number}
      name={item.name}
      packages={item.packages}
    ></ChannelRow>
  ));

  const Error = (
    <>
      <p>No results</p>
    </>
  );

  return (
    <>
      <Container>
        <Section>
          <Heading size="4" renderAs="h2">
            Channel Listing
          </Heading>
          <Block>
            <p><strong>Print Channel Guides</strong></p>
            <p><a href="https://www.ozarksgo.net/print-channel-guide?state=Arkansas" target="_blank">Arkansas</a></p>
            <p><a href="https://www.ozarksgo.net/print-channel-guide?state=Oklahoma" target="_blank">Oklahoma</a></p>
            <p><small>Legacy TV customers (service prior to Sept. 22, 2022) see channel guides <a href="https://www.ozarksgo.net/legacytv" target="_blank">here.</a></small></p>
          </Block>
          <Block>
            <Control>
              <Button.Group>
                <Button
                  color="primary"
                  size="large"
                  value="Arkansas"
                  id={"Arkansas"}
                  onClick={handleClick}
                  status={dma === "Arkansas" ? "active" : undefined}
                >
                  Arkansas
                </Button>
                <Button
                  color="primary"
                  size="large"
                  value="Oklahoma"
                  id="Oklahoma"
                  onClick={handleClick}
                  status={dma === "Oklahoma" ? "active" : undefined}
                >
                  Oklahoma
                </Button>
              </Button.Group>
              <PackagePicker
                packages={tiers}
                onClick={handleTier}
                clear={clearTier}
                currentTier={tier}
              />

              <Field>
                <Label>Search Channels</Label>
                <Input
                  value={searchInput}
                  onChange={(event) => setSearchInput(event.target.value)}
                ></Input>
              </Field>
            </Control>
          </Block>
          <FilterSummary
            tier={tier !== "" ? tier : "All channels"}
            dma={dma === "Arkansas" ? "Arkansas" : "Oklahoma"}
          ></FilterSummary>
          <Table.Container>
            <Table size="fullwidth" className="channel-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th className="has-text-centered">Local Plus</th>
                  <th className="has-text-centered">Complete Lite</th>
                  <th className="has-text-centered">Complete</th>
                  <th className="has-text-centered">Advanced</th>
                  <th className="has-text-centered">Ultra</th>
                  <th>Add-on</th>
                </tr>
              </thead>
              <tbody>{ChannelTableBody}</tbody>
            </Table>
          </Table.Container>

          {/* 
          <Columns multiline>
            {Channels.length !== 0 ? Channels : Error}
          </Columns>
          */}
        </Section>
      </Container>
    </>
  );
}

export default function App() {
  return <Channels />;
}
